<template>
<!--:modal="false" :close-on-click-modal="false"   -->
  <el-dialog ref="dialog" title="导入数据" size="large" style="min-width:1280px">
    <div class="form-tips fz-14 m-b-10">特殊文本输入格式（按顺序输入）：控件类型 | 字段名 | 字段标题 | 提示信息 | 是否必填（0为否，1为是)， 如果字段为空，则留白，一行一条数据。</div>
    <el-radio-group v-model="type">
      <el-radio label="text">特殊文本</el-radio>
      <el-radio label="json">JSON数据</el-radio>
    </el-radio-group>
    <el-input
      type="textarea"
      :rows="8"
      placeholder="请输入内容"
      v-model="text">
    </el-input>
    <span slot="footer" class="dialog-footer m-b-10">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="submit">导入</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'textImport',
    data() {
      return {
        text: '',
        type: 'text'
      }
    },
    methods: {
      openDialog() {
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      submit() {
        if (_g.isRealEmpty(this.text)) {
          _g.toastMsg(this, 'warning', '请输入内容')
          return
        }
        this.$emit('setImportText', this.type, this.text)
        this.closeDialog()
        this.text = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// textImport.vue?279bd10c